import getConfig from 'next/config';
import axios from 'axios';
import { BASE_URL } from '@constants/endpoint';

import {
  getClientHostAxiosConfig,
  getServerHostConfig,
  getServerLocale,
} from './hostConfig';

axios.defaults.withCredentials = true;
axios.defaults.withToken = true;

const { publicRuntimeConfig } = getConfig();

const timeoutMs = 15_000;

const isServer = typeof window === 'undefined';
let httpAgent;
let httpsAgent;
if (isServer) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports -- server-only
  const http = require('http');
  // eslint-disable-next-line @typescript-eslint/no-require-imports -- server-only
  const https = require('https');
  httpAgent = new http.Agent({ keepAlive: true, maxSockets: 100 });
  httpsAgent = new https.Agent({ keepAlive: true, maxSockets: 100 });
}

let resolvedBaseURL = BASE_URL;
let resolvedXCKey = publicRuntimeConfig.xcKey;

if (!isServer) {
  const clientConfig = getClientHostAxiosConfig();
  if (clientConfig) {
    resolvedBaseURL = clientConfig.baseURL;
    resolvedXCKey = clientConfig.xCKey;
  }
}

const instance = axios.create({
  baseURL: resolvedBaseURL,
  timeout: timeoutMs,
  ...(isServer ? { httpAgent, httpsAgent } : {}),
  headers: { 'X-C-KEY': resolvedXCKey },
});

// Server-side interceptor: override baseURL and X-C-KEY per request
// based on the host config set for the current SSR request
if (isServer) {
  instance.interceptors.request.use(request => {
    const hostConfig = getServerHostConfig();
    if (hostConfig) {
      request.baseURL = hostConfig.baseURL;
      request.headers['X-C-KEY'] = hostConfig.xCKey;
    }

    const locale = getServerLocale();
    if (locale) {
      request.headers['X-LOCALE'] = locale;
    }

    return request;
  });
}

export default instance;
